'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');

var graphicsHelper = require('../../helper/graphicsHelper');

var PieChart = React.createClass({

  fillCanvas: function () {

    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var context = canvas.getContext('2d');
    var style = styleHelper.StyleUtil(this.props).bounds().border().style;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var ratio = graphicsHelper.applyDeviceRatio(context,w,h);
    w *= ratio;
    h *= ratio;
    var result = graphicsHelper.parseText(styleHelper.getText(this.props));

    var data_arr = result["areas"];
    var color_arr = result["colors"];

    var startAngle = -90 * Math.PI / 180; //起始弧度
    var endAngle = -90 * Math.PI / 180;   //结束弧度

    context.lineWidth = ratio;
    if(style.borderWidth != "inherit") {   //判断是否隐藏边框
      graphicsHelper.drawEllipse(context, w, h, style.borderColor);
    }

    var total= 0.0;
    for (var i = 0; i < data_arr.length; i++) {
      total += data_arr[i];
    }
    for (var i = 0; i < data_arr.length; i++)
    {
      //绘制饼图
      endAngle = endAngle + data_arr[i]/total * Math.PI * 2; //结束弧度
      graphicsHelper.drawEllipseByAngle(context, w, h, startAngle, endAngle, color_arr[i]);
      startAngle = endAngle; //设置起始弧度
    }


  },

  componentDidMount: function () {
    this.fillCanvas();
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE,this._onResize)
  },

  _onResize : function(){
    this.fillCanvas();
  },

  componentDidUpdate: function () {
    this.fillCanvas();
  },

  render: function () {
    //获取饼状图宽高，统一canvas与饼图宽高
    var style = styleHelper.StyleUtil(this.props).size().style;
    return (
      <div className="component-SimpleCom">
        <canvas ref="canvas" width={style.width} height={style.height}>
          浏览器不支持canvas
        </canvas>

      </div>

    )
  }





});

module.exports = PieChart;



// WEBPACK FOOTER //
// ./src/views/Components/PieChartEx.jsx